import { USER_DEFAULT_AVATAR } from 'shared/constants/links';
import { TeamByMatchId, TeamDto } from '../interfaces/team-by-match-id';

export function teamByMatchDataMapper(teams: TeamDto[]): TeamByMatchId[] {
  return teams?.map((team) => {
    return {
      teamId: team?.id,
      players: team?.championshipApplications.map((application) => {
        return {
          id: application.id,
          avatar: application.user.photo?.externalUrl || USER_DEFAULT_AVATAR,
          firstName: application.user.name,
          lastName: application.user.surname,
          middleName: application.user.middleName,
          userId: application.user.id,
          number: application.number,
          position: application.position,
        };
      }),
    };
  });
}
